module.exports = __webpack_public_path__ + "img/credit-card.3ade6817.svg";